import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Çeviri hook'u
import "./navbar.css";
import Logo from "../../assets/images/thm-logo.png"
import MobileLogo from "../../assets/images/thm-mobile-logo.png"
import { FaChevronDown } from 'react-icons/fa6';

const Navbar = ({ direction, ...args }) => {
    const { t, i18n } = useTranslation(); 
    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const mobileMenuRef = useRef(null);

    const [langOpen, setLangOpen] = useState(false);
    const langMenuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target) && !event.target.closest('button[aria-label="menu"]')) {
                setIsOpen(false);
            }
            if (langMenuRef.current && !langMenuRef.current.contains(event.target)) {
                setLangOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleMenu = () => {
        setIsOpen((prevIsOpen) => !prevIsOpen);
    };

    const toggleLangMenu = () => {
        setLangOpen(!langOpen);
    };

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setLangOpen(false); 
        setIsOpen(false); 
    };

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 75);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav className={`navbar-container flex justify-around items-center relative navbar ${isScrolled ? 'fixed top-0 left-0 w-full z-50 shadow-md' : ''}`}>
            <div className='md:grid grid-cols-5 md:w-full items-center justify-around navbar-container2'>
                <div className="text-white text-xl flex justify-center navbar-logo-container">
                    <div className="logoBox flex items-center">
                        <Link className="flex items-center justify-center" to="/">
                            <img src={Logo} alt="Logo" className="navbar-logo hidden md:block" />
                            <img src={MobileLogo} alt="Mobile Logo" className="navbar-logo block md:hidden" />
                        </Link>
                    </div>
                </div>

                <div className="navbar-link-container col-span-3 hidden md:flex items-center justify-center gap-4">
                    <Link className="navbar-link" to="/about">{t('navbar.aboutUs')}</Link>
                    <Link className="navbar-link" to="/investment-opportunities">{t('navbar.investorInfo')}</Link>
                    <Link className="navbar-link" to="/investment-incentives">{t('navbar.incentives')}</Link>
                </div>

                <div className='hidden md:flex justify-end items-center gap-2 language-dropdown-container'>
                    <Link className="navbar-try-link" id='navbar-try-button' to="/contact">{t('navbar.contactTeam')}</Link>

                    <div className="relative" ref={langMenuRef}>
                        <button
                            onClick={toggleLangMenu}
                            className="navbar-try-link flex items-center gap-1 text-gray-700 h transition duration-300"
                        >
                            {i18n.language.toUpperCase()} <FaChevronDown className="text-sm" />
                        </button>

                        {langOpen && (
                            <div className="absolute right-0 mt-2 bg-white shadow-lg rounded-2xl w-max z-50 border border-gray-100 overflow-hidden">
                                <button onClick={() => changeLanguage('en')} className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100 hover:text-[#D56B21]">EN - English</button>
                                <button onClick={() => changeLanguage('ka')} className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100 hover:text-[#D56B21]">KA - ქართული</button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="md:hidden flex gap-2">
                <button onClick={toggleMenu} className="navbar-mobile-button text-black focus:outline-none" aria-label="menu">
                    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                    </svg>
                </button>
            </div>

            {isOpen && (
                <div ref={mobileMenuRef} className="absolute top-[80px] p-4 flex flex-col bg-[#caeffc] space-y-2 md:hidden mobile-navbar-page shadow-lg z-50">
                    <Link onClick={() => setIsOpen(false)} to="/about" className="text-lg font-medium">{t('navbar.aboutUs')}</Link>
                    {/* <Link onClick={() => setIsOpen(false)} to="/services" className="text-lg font-medium">{t('navbar.ourServices')}</Link> */}
                    <Link onClick={() => setIsOpen(false)} to="/investment-opportunities" className="text-lg font-medium">{t('navbar.investorInfo')}</Link>
                    <Link onClick={() => setIsOpen(false)} to="/investment-incentives" className="text-lg font-medium">{t('navbar.incentives')}</Link>

                    <hr className="border-gray-300" />

                    <Link onClick={() => setIsOpen(false)} className="navbar-try-link w-max text-lg" id='navbar-try-button-mobile' to="/contact">{t('navbar.contactUs')}</Link>

                    <div className="pt-2 flex gap-4">
                        <span className="font-semibold text-gray-700">Language:</span>
                        <button onClick={() => changeLanguage('en')} className={`font-medium ${i18n.language === 'en' ? 'text-[#D56B21]' : 'text-gray-600'}`}>EN</button>
                        <span>|</span>
                        <button onClick={() => changeLanguage('ka')} className={`font-medium ${i18n.language === 'ka' ? 'text-[#D56B21]' : 'text-gray-600'}`}>KA</button>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;